import React from 'react';

export default class Component extends React.Component {
    render() {
        return <div>Welcome</div>;
    }
}
